import * as actionTypes from '../constant/insight'
import {apiCall} from '../../service/apiCall'
import {setLoading} from './general'
import {get} from 'lodash'
import { URL, USER,PASS } from '../../service/base_url'
export const getInsight=(slug='')=>async dispatch=>{
    dispatch(setLoading(true))
    let dataReq={
        url:`/km/insight/intro${slug}/1`,
        method:'GET',
        data:{
            auth:{username:USER,password:PASS}
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')==200){
        dispatch(setLoading(false))
        dispatch({
            type:actionTypes.GET_INSIGHT,
            payload:res.data
        })
        return res
    }else{
        dispatch(setLoading(false))

       
    }
}
export const getTopic=(slug='')=>async dispatch=>{
    dispatch(setLoading(true))
    let dataReq={
        url:`/event/topic`,
        method:'GET',
        data:{
            auth:{username:USER,password:PASS}
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')==200){
        dispatch(setLoading(false))
        let new_topic=[]
        res.data.map((data)=>{
            new_topic.push({...data,checked:false})
        })
        dispatch({
            type:actionTypes.GET_TOPIC,
            payload:new_topic
        })
        return res
    }else{
        dispatch(setLoading(false))

       
    }
}
